<template>
  <div>
    <h2 class="page-title">号段分配</h2>
    <div class="card-panel" style="padding:20px;margin-bottom:20px;">
      <el-form :model="form" label-position="top" class="form-grid">
        <el-form-item label="供应商">
          <el-select v-model="form.vendorId" placeholder="请选择供应商">
            <el-option v-for="vendor in vendors" :key="vendor.id" :label="`${vendor.name} / ${vendor.shortCode}`" :value="vendor.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="SN段1">
          <el-input v-model="form.segmentCode" maxlength="4" placeholder="4位数字" />
        </el-form-item>
        <el-form-item label="状态" v-if="form.id">
          <el-select v-model="form.status">
            <el-option label="active" value="active" />
            <el-option label="inactive" value="inactive" />
          </el-select>
        </el-form-item>
      </el-form>
      <div style="display:flex;gap:12px;flex-wrap:wrap;">
        <el-button type="primary" @click="submit">{{ form.id ? '保存分配' : '分配号段' }}</el-button>
        <el-button v-if="form.id" @click="resetForm">取消编辑</el-button>
      </div>
    </div>

    <div class="card-panel" style="padding:20px;">
      <el-table :data="segments" width="100%">
        <el-table-column prop="vendorName" label="供应商" />
        <el-table-column prop="segmentCode" label="SN段1" width="100" />
        <el-table-column prop="status" label="状态" width="100" />
        <el-table-column prop="snCount" label="已签发数" width="100" />
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="editSegment(scope.row)">编辑</el-button>
            <el-button type="text" style="color:#f56c6c;" @click="removeSegment(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { createSegment, deleteSegment, getSegments, getVendors, updateSegment } from '../../api/admin'

const defaultForm = () => ({
  id: null,
  vendorId: '',
  segmentCode: '',
  status: 'active',
})

export default {
  data() {
    return {
      form: defaultForm(),
      vendors: [],
      segments: [],
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const [vendorsRes, segmentsRes] = await Promise.all([getVendors(), getSegments()])
      this.vendors = vendorsRes.data
      this.segments = segmentsRes.data
    },
    resetForm() {
      this.form = defaultForm()
    },
    editSegment(row) {
      this.form = {
        id: row.id,
        vendorId: row.vendorId,
        segmentCode: row.segmentCode,
        status: row.status,
      }
    },
    async removeSegment(row) {
      try {
        await this.$confirm(`确认删除号段 ${row.segmentCode}？`, '提示', { type: 'warning' })
        await deleteSegment(row.id)
        this.$message.success('删除成功')
        this.loadData()
        if (this.form.id === row.id) this.resetForm()
      } catch (error) {
        if (error !== 'cancel') this.$message.error(error.response?.data?.message || '删除失败')
      }
    },
    async submit() {
      try {
        if (this.form.id) {
          await updateSegment(this.form.id, this.form)
          this.$message.success('更新成功')
        } else {
          await createSegment(this.form)
          this.$message.success('分配成功')
        }
        this.resetForm()
        this.loadData()
      } catch (error) {
        this.$message.error(error.response?.data?.message || '操作失败')
      }
    },
  },
}
</script>
